export default class classEnum {
    static SCHOOL_COURSES = 'schoolcourses';
    static FALLBACK_ID = -1;
}



// WEBPACK FOOTER //
// ./app/containers/class-roll/constants.js